import { r as s, c as r, h as a, g as o } from "./main-bb89b2f2.js";
import "vue";
const n = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.static{position:static}.box-border{box-sizing:border-box}.grid{display:grid}.justify-start{justify-content:flex-start}.mt-\\[8px\\]{margin-top:8px}.flex{display:flex}.items-center{align-items:center}.block{display:block}", h = n, l = class {
  constructor(t) {
    s(this, t), this.change = r(this, "lhChange", 7), this.controlled = !1, this.gap = "16px", this.gridWrap = !1, this.horizontal = !1, this.itemsMinWidth = "196px", this.value = "", this.name = "radio", this.status = "default", this.wcag = "AAA", this.width = "100%";
  }
  valueWatcher(t) {
    this.handleValueChange(t);
  }
  statusWatcher() {
    this.queryRadiobuttonItems().forEach((e) => {
      e.status = this.status;
    });
  }
  handleRadioButtonItemChange(t) {
    const e = t.detail;
    this.controlled || (this.value = e), this.change.emit({ value: e, name: this.name });
  }
  componentWillLoad() {
    this.handleValueChange(this.value);
  }
  componentDidLoad() {
    const t = this.queryRadiobuttonItems();
    if (t.length === 0)
      throw new Error("[patternlib-radiobutton] Must have at least one item");
    t.forEach((e) => {
      e.name = this.name, e.status = this.status, e.wcag = this.wcag;
    });
  }
  render() {
    const t = {
      "grid justify-start box-border": !0
    }, e = {
      gridAutoFlow: this.horizontal ? this.gridWrap ? "" : "column" : "row",
      gridTemplateColumns: this.horizontal && this.gridWrap && `repeat(auto-fit, minmax(${this.itemsMinWidth}, 1fr))`,
      "grid-gap": this.gap,
      width: this.width
    };
    return a("patternlib-form-group", { key: "e6a36741b43a42b6dcc227640286d7960e4034df", status: this.status, tabindex: "0" }, a("div", { key: "b18755ec9ea3af9be31a8898dd01d5171d87c971", slot: "element", class: t, style: e }, a("slot", { key: "1fa303bed82db865c5dd4d3d5e931edf38a02a04" })));
  }
  handleValueChange(t) {
    const e = this.queryRadiobuttonItems();
    if (t == null) {
      e.forEach((i) => i.checked = !1);
      return;
    }
    e.forEach((i) => i.checked = i.value === t);
  }
  queryRadiobuttonItems() {
    const t = this.hostElement.querySelectorAll("patternlib-radiobutton-item");
    return Array.from(t);
  }
  get hostElement() {
    return o(this);
  }
  static get watchers() {
    return {
      value: ["valueWatcher"],
      status: ["statusWatcher"]
    };
  }
};
l.style = h;
export {
  l as patternlib_radiobutton
};
